"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteApplicationsCommand = void 0;
const AbstractFilteredApplicationsCommand_1 = require("./AbstractFilteredApplicationsCommand");
const SearchApplicationsCommand_1 = require("./SearchApplicationsCommand");
const NotFoundError_1 = require("../../errors/NotFoundError");
class DeleteApplicationsCommand extends AbstractFilteredApplicationsCommand_1.AbstractFilteredApplicationsCommand {
    async exec() {
        const deletePromises = (await new SearchApplicationsCommand_1.SearchApplicationsCommand(this.api).withFilter(this.filter).execute()).list.map(async (application) => await this.api.delete(`/applications/${application.pushApplicationID}`).then(() => application));
        if (deletePromises.length < 1) {
            throw new NotFoundError_1.NotFoundError("Can't find requested application", this.filter);
        }
        return Promise.all(deletePromises);
    }
}
exports.DeleteApplicationsCommand = DeleteApplicationsCommand;
//# sourceMappingURL=DeleteApplicationsCommand.js.map